module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-overlay"
  }, [_c('div', {
    staticClass: "popup"
  }, [_c('button', {
    staticClass: "close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.close(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('h1', [_vm._v("Fellebbezés")]), _vm._v(" "), _c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n      Figyelem! Fellebbezését csak egyszer nyújthatja be.\n    ")]), _vm._v(" "), _c('textareabox', {
    attrs: {
      "cstyle": "height: 200px; width: 400px;",
      "autogrow": true,
      "maxlength": "2000",
      "id": "msg",
      "label": "Üzenet",
      "errors": _vm.errors,
      "name": "msg"
    },
    model: {
      value: (_vm.msg),
      callback: function($$v) {
        _vm.msg = $$v
      },
      expression: "msg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group last"
  }, [_c('button', {
    staticClass: "button v2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Beküld")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ec17ca9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/fellebezes.vue
// module id = 369
// module chunks = 0